import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { VideoArchiveTemplate } from "../video-archive-template";

const CXOChroniclePage = (props) => {
    const collection = get(props, ["data", "collection"], {});
    return <VideoArchiveTemplate collection={collection} pageName="CXO Chronicle" />;
};

CXOChroniclePage.propTypes = {
    data: PropTypes.shape({
        collection: PropTypes.object
    })
};

export { CXOChroniclePage };
